import HostAllStaffModal from './container'

export default HostAllStaffModal
